<div class="wrap">
  <fa-icon [icon]="faPaperPlane"></fa-icon>
  <h1>Inscription réussie !</h1>
  <p>Votre inscription a bien été enregistrée.</p>
  <p>Un mail de confirmation vous a été envoyé à l'adresse mail <span>{{email}}</span> </p>
  <p>Veuillez confirmer votre adresse mail </p>
  <p class="redirection">Redirection en cours <span>.</span><span>.</span><span>.</span> </p>
</div>
